import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['form', 'actions', 'trixToolBar', 'displayContent', 'editorContainer'];

  showActions() {
    if (this.hasActionsTarget) {
      this.formTarget.classList.add("form-focused");
    } else {
      const parentForm = this.element.closest('form');
      if (parentForm) {
        parentForm.classList.add("form-focused");
      }
    }

    const allEditorContainers = document.querySelectorAll("[data-focuseable-form-target='editorContainer']");
    const allDisplayContents = document.querySelectorAll("[data-focuseable-form-target='displayContent']");

    allEditorContainers.forEach(container => container.classList.remove("hidden"));
    allDisplayContents.forEach(content => content.classList.add("hidden"));
  }

  hideActions() {
    this.formTarget.classList.remove("form-focused");

    if (this.hasEditorContainerTarget) {
      this.editorContainerTarget.classList.add("hidden");
    }
    if (this.hasDisplayContentTarget) {
      this.displayContentTarget.classList.remove("hidden");
    }

    const allEditorContainers = document.querySelectorAll("[data-focuseable-form-target='editorContainer']");
    const allDisplayContents = document.querySelectorAll("[data-focuseable-form-target='displayContent']");

    allEditorContainers.forEach(container => container.classList.add("hidden"));
    allDisplayContents.forEach(content => content.classList.remove("hidden"));
  }
}
